export default "__VITE_ASSET__C29vKvW1__"